import api from "../../../api";
import { PUBLIC_ROUTES } from "../../../routes";
import urls from "../../../urls";

export const logout = async () => {
  try {
    await api.request("POST", urls.auth.logout());
  } catch {
    // If logout request fails (e.g. expired refresh token cookie),
    // still clear client state and redirect.
  }

  api.setAccessToken();
  location.replace(PUBLIC_ROUTES.login);
};
